export const camelize = (word: string = '') => {
  const lowerCase = word.toLowerCase()
  if (lowerCase.length > 0) {
    const firstChar = lowerCase[0]
    return firstChar.toUpperCase() + lowerCase.substr(1)
  }
  return ''
}
